import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    searchTerm: '',
    business: { display: '', value: '' },
    store: { display: '', value: '' },
  },
};

const deviceDashboardSlice = createSlice({
  name: 'deviceDashboard',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.filters.searchTerm = action.payload;
    },
    setBusiness: (state, action) => {
      state.filters.business = action.payload;
    },
    setStore: (state, action) => {
      state.filters.store = action.payload;
    },
  },
});

export const { setSearch, setBusiness, setStore } = deviceDashboardSlice.actions;
export default deviceDashboardSlice.reducer;
